import { FiMenu } from 'react-icons/fi';
import Input from '../Input';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

const TeacherNav = ({ openSidebar, side, closeSidebar, searchBar }) => {
  const [name, setName] = useState('Admin');
  const [photo, setPhoto] = useState(null);
  useEffect(() => {
    const storedAdminData = localStorage.getItem('userData');
    if (storedAdminData) {
      const admin = JSON.parse(storedAdminData);
      setName(admin?.name || 'Admin');
      setPhoto(admin?.photo);
    } else {
      console.log('No admin data found in local storage.');
    }
  }, []);
  return (
    <nav
      className={`fixed   z-30 top-0 right-0   ${
        side === 'left-0 md:-left-64' ? 'left-0' : 'left-0 md:left-64'
      }`}
    >
      <div className="  w-full flex justify-between  items-center p-4">
        <div className=" flex items-center gap-4">
          <div className=" block  md:hidden">
            {side === 'left-0 md:-left-64' ? (
              <FiMenu size={30} onClick={closeSidebar} color="black" />
            ) : (
              <FiMenu size={30} color="black" onClick={openSidebar} />
            )}
          </div>

          <div className=" hidden md:block w-96">{searchBar}</div>
        </div>

        <div className=" flex items-center gap-5">
          <div className=" ">
            <p className=" font-medium">{name}</p>
          </div>
          <Link to="/teacher-settings">
            {photo ? (
              <img src={photo} className=" w-12 h-12 rounded-full" />
            ) : (
              <img
                src={require('../../assets/image/profile.jpg')}
                className=" w-12 h-12 rounded-full"
              />
            )}
          </Link>
        </div>
      </div>
    </nav>
  );
};
export default TeacherNav;
